module.exports = __webpack_public_path__ + "media/src/img/banner-bg-c22101013515322ab33b3ab56f25a223.jpg";